<template>
  <div v-if="canView === true">
    <h2 class="p-conversion__ttl c-ttl3" v-if="hasHeading === true">
      オプション
    </h2>
    <div
      class="p-conversion"
      :class="[
        clickable === true && selectedNav === identifier ? 'is-selected' : '',
        clickable === true ? 'is-clickable' : '',
        hasBorder === true ? 'has-border' : '',
      ]"
      @click="changeSelectedNav()"
    >
      <h3 class="p-conversion__ttl2 c-ttl2">
        {{ identifier | getIdentifierName }}
      </h3>
      <div class="p-conversion__row">
        <div
          class="p-conversion__thumb"
          v-if="thumbUrl"
          style="background: #eee"
        >
          <img :src="thumbUrl" alt />
        </div>
        <p class="p-conversion__txt">{{ name }}</p>
        <p class="p-conversion__value">
          <span class="p-conversion__price c-price">
            <span class="p-conversion__price__value c-price__value">
              {{ price | addComma }}
            </span>
            <span class="p-conversion__price__unit c-price__unit">円</span>
          </span>
        </p>
      </div>
      <p class="p-conversion__note" v-if="this.isStoppedOptions">
        ※カーボンルーフは現在受注停止中です
      </p>
      <template v-if="selectedNav === identifier">
        <p class="p-conversion__note" v-if="identifier === 'caliper'">
          ※ブレーキディスク、キャリパーのサイズは全て同一です
        </p>
        <p
          class="p-conversion__note"
          v-if="
            identifier === 'handle' ||
              identifier === 'tire' ||
              identifier === 'gtsExteriorExhaust' ||
              identifier === 'roof'
          "
        >
          ※車種画像には反映されません
        </p>
      </template>
      <div class="p-conversion__row2" v-if="hasMenu">
        <change-menu
          :identifier="identifier"
          :identifierName="identifier | getIdentifierName"
          :selectedItem="selectedItem"
          :selectMenu="selectMenu"
          :stoppedEnditems="stoppedEnditems"
          :gtsExteriorMap="gtsExteriorMap"
          :gtsExteriorAeroCombination="gtsExteriorAeroCombination"
          device="sp"
          @change-menu="changeMenu"
          @change-grade="changeGrade"
        ></change-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { getHandleName, getThumbUrl } from "../util/util";
import { addComma, getIdentifierName } from "../util/filter";
import ChangeMenu from "../components/ChangeMenu";

export default {
  name: "Conversion",
  components: {
    ChangeMenu,
  },
  props: {
    identifier: String,
    select: Object,
    selectedItem: Object,
    selectedNav: String,
    basePrice: Number,
    clickable: Boolean,
    hasBorder: Boolean,
    hasHeading: Boolean,
    stoppedEnditems: {
      colors: Array
    },
    gtsExteriorMap: Object,
    gtsExteriorAeroCombination: Object,
  },
  computed: {
    price() {
      // ハンドルは常に0を返す
      if (this.identifier === "handle") {
        return 0;
      }
      if (!this.selectMenu || !this.code) return;
      // グレードはbase_priceを参照する
      if (this.identifier === "grade") {
        return this.basePrice;
      } else {
        return this.selectedEndItem.price;
      }
    },
    name() {
      // ハンドルの場合gradeをみる
      if (this.identifier === "handle") {
        if (!this.selectedItem.enditem.grade) return;
        return getHandleName(this.selectedItem.enditem.grade);
      }

      if (!this.selectMenu || !this.code) return;
      return this.selectedEndItem.name;
    },
    code() {
      return this.selectedItem.enditem[this.identifier];
    },
    thumbUrl() {
      if (!this.selectMenu || !this.code) return;
      // 特定のものの場合はfalse
      if (
        this.identifier === "grade" ||
        this.identifier === "roof" ||
        this.identifier === "gtsExteriorRoof" ||
        this.identifier === "gtsExteriorAero" ||
        this.identifier === "gtsExteriorExhaust" ||
        this.identifier === "tire" ||
        this.identifier === "handle"
      ) {
        return false;
      }
      return getThumbUrl(this.code, this.identifier, this.carType);
    },
    hasMenu() {
      if (this.identifier === "grade") {
        return false;
      } else {
        return true;
      }
    },
    selectMenu() {
      if (!this.select) return;
      return this.select[this.identifier];
    },
    selectedEndItem() {
      if (!this.selectMenu || !this.code) return;

      // 多段メニュー構造になっていない場合
      if (this.selectMenu[this.code]) {
        return this.selectMenu[this.code];
      }
      // 多段メニュー構造になっている場合は一つ下の階層からマッチするものを探す
      else {
        let item = {};
        Object.keys(this.selectMenu).forEach((key) => {
          if (this.selectMenu[key] && this.selectMenu[key][this.code]) {
            item = this.selectMenu[key][this.code];
            return;
          }
        });
        return item;
      }
    },
    carType() {
      return this.$route.params.cartype;
    },
    // 受注停止のものが存在するアイテムかどうか
    isStoppedOptions() {
      return false;
    },
    // ものによって表示させたくないものの処理
    // アルピーヌコードに紐づいた処理
    canView() {
      // a110gtsのみオプションのタイヤを表示する
      if (this.identifier === "tire" && this.carType === "a110gts") {
        return true;
      } else if(this.identifier === "tire") {
        return false;
      }

      // a110gts用のデータはa110gtsにのみ表示する
      if (
        (
          this.identifier === "gtsExteriorRoof" ||
          this.identifier === "gtsExteriorAero" ||
          this.identifier === "gtsExteriorExhaust"
        ) && this.carType === "a110gts")
      {
        return true;
      } else if (
        this.identifier === "gtsExteriorRoof" ||
        this.identifier === "gtsExteriorAero" ||
        this.identifier === "gtsExteriorExhaust"
      ) {
        return false;
      }

      // a110gtsでは標準のroofは表示しない
      if (this.identifier === "roof" && this.carType === "a110gts") {
        return false;
      }
      // a110

      return true
    }
  },
  methods: {
    changeSelectedNav() {
      if (!this.clickable) return;
      this.$emit("change-selected-nav", this.identifier);
    },
    changeMenu(code, identifier) {
      this.$emit("change-menu", code, identifier);
    },
    changeGrade(grade) {
      this.$emit("change-grade", grade);
    },
  },
  watch: {
  },
  filters: {
    addComma,
    getIdentifierName,
  },
};
</script>
